import { render, staticRenderFns } from "./TopCreate.vue?vue&type=template&id=05429b4e&scoped=true"
import script from "./TopCreate.vue?vue&type=script&lang=js"
export * from "./TopCreate.vue?vue&type=script&lang=js"
import style0 from "./TopCreate.vue?vue&type=style&index=0&id=05429b4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05429b4e",
  null
  
)

export default component.exports